<template>
  <main>
    <div class="row">
      <div class="col-12 col-lg-3 event--card">
        <atom-card-with-loading
          cardTopic="EVENTS"
          linkTo="/server-management/all-events"
          ><molecule-event-card
            v-for="(event, index) in eventList"
            :key="index"
            :equipmentData="event"
          ></molecule-event-card>
          <p v-if="eventList.length === 0" class="event__text">
            No event for the last 24 hours
          </p>
        </atom-card-with-loading>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 cpu--card resource--card">
            <atom-card-with-loading cardTopic="CPU">
              <div v-if="cpuList.length">
                <molecule-resource-card
                  v-for="(cpu, index) in cpuList"
                  :key="index"
                  resourceType="cpu"
                  :resourceData="cpu"
                ></molecule-resource-card>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span> No Data </span>
              </div>
            </atom-card-with-loading>
          </div>
          <div class="col-12 col-md-4 col-lg-4 memory--card resource--card">
            <atom-card-with-loading cardTopic="MEMORY">
              <div v-if="memoryList.length">
                <molecule-resource-card
                  v-for="(memory, index) in memoryList"
                  :key="index"
                  resourceType="memory"
                  :resourceData="memory"
                ></molecule-resource-card>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span> No Data </span>
              </div>
            </atom-card-with-loading>
          </div>
          <div class="col-12 col-md-4 col-lg-4 storage--card resource--card">
            <atom-card-with-loading cardTopic="STORAGE USAGE">
              <div v-if="storageList.length">
                <molecule-resource-card
                  v-for="(storage, index) in storageList"
                  :key="index"
                  resourceType="storage"
                  :resourceData="storage"
                ></molecule-resource-card>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span> No Data </span>
              </div>
            </atom-card-with-loading>
          </div>
          <div class="col-12 equipment-resource--card">
            <atom-card-with-loading
              cardTopic="EQUIPMENT RESOURCE"
              linkTo="/server-management/server-management"
            >
              <div v-if="equipmentResourceList.length">
                <molecule-equipment-resource
                  v-for="(equipment, index) in equipmentResourceList"
                  :key="index"
                  :equipmentResourceListData="equipment"
                ></molecule-equipment-resource>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span> No Data </span>
              </div>
            </atom-card-with-loading>
          </div>
        </div>
      </div>
    </div>
    <footer style="height: 14px"></footer>
  </main>
</template>

<script>
import AtomCardWithLoading from "@/components/atoms/AtomCardWithLoading.vue"
import MoleculeEventCard from "@/components/molecules/serverManagementModule/dashboard/MoleculeEventCard.vue"
import MoleculeResourceCard from "@/components/molecules/serverManagementModule/dashboard/MoleculeResourceCard.vue"
import MoleculeEquipmentResource from "@/components/molecules/serverManagementModule/dashboard/MoleculeEquipmentResource.vue"
export default {
  components: {
    AtomCardWithLoading,
    MoleculeEventCard,
    MoleculeResourceCard,
    MoleculeEquipmentResource,
  },
  name: "OrganismDashboard",
  props: {
    eventList: {
      type: Array,
      required: true,
    },
    cpuList: {
      type: Array,
      required: true,
    },
    memoryList: {
      type: Array,
      required: true,
    },
    storageList: {
      type: Array,
      required: true,
    },
    equipmentResourceList: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.event--card {
  padding: 0 14px;
}

.cpu--card {
  padding: 10px 14px 5px 14px;
}

.memory--card,
.storage--card {
  padding: 5px 14px 5px 14px;
}

.equipment-resource--card {
  padding: 10px 14px 0 14px;
}

.equipment-resource--card ::v-deep.content__max-height {
  height: 400px;
  max-height: 400px;
  overflow-y: auto;
}

.event--card ::v-deep.content__max-height {
  height: 225px;
  max-height: 225px;
  overflow-y: auto;
}

.resource--card ::v-deep.content__max-height {
  height: 225px;
  max-height: 225px;
  overflow-y: auto;
}

.event__text {
  color: #909399;
  width: 100%;
  display: flex;
  justify-content: center;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .cpu--card {
    padding: 10px 5px 0 14px;
  }
  .memory--card {
    padding: 10px 5px 0 5px;
  }
  .storage--card {
    padding: 10px 14px 0 5px;
  }
  .equipment-resource--card {
    padding: 10px 14px 10px 14px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  footer {
    display: none;
  }
  .event--card {
    padding: 0 5px 0 14px;
  }
  .cpu--card,
  .memory--card {
    padding: 0 5px;
  }

  .storage--card {
    padding: 0 14px 0 5px;
  }

  .equipment-resource--card {
    padding: 10px 14px 0 5px;
  }
  .event--card ::v-deep.content__max-height {
    height: calc(100vh - 17.75rem);
    max-height: calc(100vh - 17.75rem);
    overflow-y: auto;
  }
  .equipment-resource--card ::v-deep.content__max-height {
    height: calc(100vh - 35.5rem);
    max-height: calc(100vh - 35.5rem);
    overflow-y: auto;
  }
  .resource--card ::v-deep.content__max-height {
    height: 180px;
    max-height: 180px;
    overflow-y: auto;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
